import React from 'react';
import { IonItem, IonLabel, IonCheckbox } from '@ionic/react';
import {_getIndianStates, _getReligionOptions} from "../apiHelpers/CommonHelper";
import useStore from "../zustand/useStore";
import {actionToGetMatrimonialPostingByFilter} from "../apiHelpers/CommonAction";

export default function MatrimonyFilterSidebar() {
    const {
        selectedReligion, setSelectedReligion,
        selectedAge, setSelectedAge,
        selectedEducation, setSelectedEducation,
        selectedLocation, setSelectedLocation,
        selectedMeritialStatus, setSelectedMeritialStatus,
        selectedHeight, setSelectedHeight,
        selectedManglikStatus, setSelectedManglikStatus,
        resetMatrimonialFilters
    } = useStore();

    const handleApplyMatrimonialFilters = async (
        religion,
        age,
        education,
        location,
        meritialStatus,
        height,
        manglikStatus
    ) => {
        const payload = {};
        if (religion.length > 0) payload.religion = religion;
        if (age > 0) payload.age = age;
        if (education.length > 0) payload.education = education;
        if (location.length > 0) payload.location = location;
        if (meritialStatus.length > 0) payload.meritial_status = meritialStatus;
        if (height > 0) payload.height = height;
        if (manglikStatus.length > 0) payload.manglik_status = manglikStatus;
        payload.me_mode = false;

        await actionToGetMatrimonialPostingByFilter(true, payload);
    };

    const handleClearMatrimonialFilters = async () => {
        resetMatrimonialFilters();
        await actionToGetMatrimonialPostingByFilter(true, {me_mode:false});
    };

    const handleReligionChange = async (value) => {
        let religions;
        if (selectedReligion.includes(value)) {
            religions = selectedReligion.filter((v) => v !== value);
        } else {
            religions = [...selectedReligion, value];
        }

        setSelectedReligion(religions);
        handleApplyMatrimonialFilters(
            religions,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus
        );
    };

    const handleAgeChange = async (value) => {
        setSelectedAge(value);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            value,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus
        );
    };

    const handleEducationChange = async (value) => {
        let education;
        if (selectedReligion === value) {
            education = ''
        } else {
            education = value;
        }
        setSelectedEducation(education);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            education,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus
        );
    };

    const handleLocationChange = async (value) => {
        let location;
        if (selectedLocation.includes(value)) {
            location = selectedLocation.filter((v) => v !== value);
        } else {
            location = [...selectedLocation, value];
        }

        setSelectedLocation(location);
        handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            location,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus
        );
    };

    const handleMeritialStatusChange = async (value) => {
        let maritialStatus;
        if (selectedMeritialStatus.includes(value)) {
            maritialStatus = selectedMeritialStatus.filter((v) => v !== value);
        } else {
            maritialStatus = [...selectedMeritialStatus, value];
        }

        setSelectedMeritialStatus(maritialStatus);
        handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            maritialStatus,
            selectedHeight,
            selectedManglikStatus,
        );
    };

    const handleHeightChange = async (value) => {
        setSelectedHeight(value);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            value,
            selectedManglikStatus
        );
    };

    const handleManglikStatusChange = async (value) => {
        let manglikStatus;
        if (selectedManglikStatus === value) {
            manglikStatus = ''
        } else {
            manglikStatus = value;
        }
        setSelectedManglikStatus(manglikStatus);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            manglikStatus
        );
    };

    const showApplyButton =
        selectedReligion.length > 0 ||
        selectedAge > 0 ||
        selectedEducation.length > 0 ||
        selectedLocation.length > 0 ||
        selectedMeritialStatus.length > 0 ||
        selectedHeight > 0 ||
        selectedManglikStatus.length > 0;



    return (
        <div className="filter-sidebar-content">
            <div className={"filter_main_heading_container"}>
                <h3 className="filter_main_heading">All Filters</h3>
                {(showApplyButton) && (
                    <div className="filter-section-button-he clear" onClick={handleClearMatrimonialFilters}>Clear</div>
                )}
            </div>

            {/* Religion */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Religion</h4>
                {_getReligionOptions.map((religionOption) => (
                    <IonItem key={religionOption} lines="none">
                        <IonCheckbox
                            slot="start"
                            checked={selectedReligion.includes(religionOption)}
                            onIonChange={() => handleReligionChange(religionOption)}
                        />
                        <IonLabel>{religionOption}</IonLabel>
                    </IonItem>
                ))}
            </div>

            <hr/>

            {/* Age */}
            {/*<div className="filter-section">*/}
            {/*    <h4 className="filter_main_heading_2">Age Range</h4>*/}
            {/*    <IonRange*/}
            {/*        min={18}*/}
            {/*        max={40}*/}
            {/*        pin*/}
            {/*        snaps*/}
            {/*        step={1}*/}
            {/*        value={selectedAge}*/}
            {/*        onIonChange={(e) => handleAgeChange(e.detail.value)}*/}
            {/*    />*/}
            {/*    <div className="range-labels">*/}
            {/*        <span>18 yrs</span>*/}
            {/*        <span>40 yrs</span>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <hr/>

            {/* Education */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Education</h4>
                {["Graduate", "Post Graduate", "Doctorate"].map((edu) => (
                    <IonItem lines="none" key={edu}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedEducation === edu}
                            onIonChange={() => handleEducationChange(edu)}
                        />
                        <IonLabel>{edu}</IonLabel>
                    </IonItem>
                ))}
            </div>

            <hr/>

            {/* Location */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Location</h4>
                {_getIndianStates.map((location) => (
                    <IonItem key={location} lines="none">
                        <IonCheckbox
                            slot="start"
                            checked={selectedLocation.includes(location)}
                            onIonChange={() => handleLocationChange(location)}
                        />
                        <IonLabel>{location}</IonLabel>
                    </IonItem>
                ))}
            </div>

            <hr/>

            {/* Marital Status */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Marital Status</h4>
                {["Never Married", "Divorced", "Widowed"].map((status) => (
                    <IonItem lines="none" key={status}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedMeritialStatus.includes(status)}
                            onIonChange={() => handleMeritialStatusChange(status)}
                        />
                        <IonLabel>{status}</IonLabel>
                    </IonItem>
                ))}
            </div>

            <hr/>

            {/* Height */}
            {/*<div className="filter-section">*/}
            {/*    <h4 className="filter_main_heading_2">Height Range (in cm)</h4>*/}
            {/*    <IonRange*/}
            {/*        min={140}*/}
            {/*        max={200}*/}
            {/*        pin*/}
            {/*        snaps*/}
            {/*        step={1}*/}
            {/*        value={selectedHeight}*/}
            {/*        onIonChange={(e) => handleHeightChange(e.detail.value)}*/}
            {/*    />*/}
            {/*    <div className="range-labels">*/}
            {/*        <span>140 cm</span>*/}
            {/*        <span>200 cm</span>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <hr/>

            {/* Manglik */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Manglik</h4>
                {["Manglik", "Non-Manglik"].map((mStatus) => (
                    <IonItem lines="none" key={mStatus}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedManglikStatus === mStatus}
                            onIonChange={() => handleManglikStatusChange(mStatus)}
                        />
                        <IonLabel>{mStatus}</IonLabel>
                    </IonItem>
                ))}
            </div>
        </div>
    );
}
